import { formatNumericText } from '@shared/utils/formatNumericText';
import { BillingAddress, SmsTopUpInvoiceRecipient } from './AccountPrePaidBalance.access';

const money = (minor: number) => formatNumericText(minor / 100, { precision: 2, numberWithSpace: true }) ?? '';

// The top-up's VAT, from the amount excl. VAT and the total, in minor units (SmsTopUpTotal.vue). The rate is worked out from the
// two, to one decimal (Finland's 25.5 %): Chargebee taxes the whole line at one rate, so this is the rate it applied.
export function vatBreakdown(net: number, total: number): { net: string; vat: string; rate: string; total: string } {
    const rate = net > 0 ? Math.round(((total - net) / net) * 1000) / 10 : 0;
    return {
        net: money(net),
        vat: money(total - net),
        rate: formatNumericText(rate, { precision: Number.isInteger(rate) ? 0 : 1 }) ?? '',
        total: money(total),
    };
}

export function billingAddressText(address: BillingAddress | null): string {
    return [address?.Line1, address?.Zip, address?.City, address?.Country].filter(Boolean).join(', ');
}

// Mirror of the server's own-details check (SmsTopUpFacade.NormaliseRecipient): the required fields, and an e-mail that looks
// like one address. No own details is valid. The server stays authoritative.
export function recipientIsValid(recipient: SmsTopUpInvoiceRecipient | null): boolean {
    if (!recipient) return true;
    const filled = [recipient.Company, recipient.Line1, recipient.City, recipient.Zip].every((v) => v.trim() !== '');
    const email = recipient.Email?.trim() ?? '';
    return filled && (email === '' || /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/.test(email));
}
